import { gqlNoteModifierEnum as NOTE_MODIFIER } from '@minecraft.graphql-types';

export const NOTE_MODIFIER_OPTIONS = [
  { icon: 'permanent-note-green', value: NOTE_MODIFIER.VERY_GOOD_PROFILE },
  { icon: 'permanent-note-orange', value: NOTE_MODIFIER.GOOD_PROFILE },
  { icon: 'permanent-note-red', value: NOTE_MODIFIER.BAD_PROFILE },
  { icon: 'permanent-note-black', value: NOTE_MODIFIER.VERY_BAD_PROFILE },
];
